module.exports = __webpack_public_path__ + "static/logo-obs-85d6b7faf23c04c7142f74941f55a685.png";